module.exports = __webpack_public_path__ + "static/media/29ADMSPC23.a5c8fbe0.jpg";